import React from 'react';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'src/decorator/inject-intl';
import Base from 'src/core/base';
import Sku from './components/sku';

interface Prop {
    commodity: any;
    config: any;
    onShipInfoChange: (spuAttr: any) => void;
    onSubmitOrder: (shipInfo: any) => void;
    onPackageChange: (pkg: any) => void;
    onSpuAttrChange: (spuArr: any) => void;
    onRemoteRegion: (region: any) => void;
}
interface State {
    selectedPackage: any;
    selectedSpuArr: any;
    region: any;
}

@injectIntl()
export default class BuyInfo extends Base<Prop, State> {
    constructor(prop: Prop) {
        super(prop);
        this.state = { selectedPackage: {}, selectedSpuArr: [], region: { remoteLogisticsFee: 0 } };
    }

    packageChangeHandler = (com: any) => {
        this.props?.onPackageChange(com);

        this.setState({ selectedPackage: com });
    };

    changeSkuHandler = (spuArr: any[]) => {
        this.props?.onSpuAttrChange(spuArr);
        this.setState({ selectedSpuArr: spuArr });
    };

    onRemoteRegionHandler = (region: any) => {
        this.setState({ region });
        this.props.onRemoteRegion(region);
    };

    render() {
        const { commodity, config, onShipInfoChange, onSubmitOrder } = this.props;
        const { selectedPackage, region } = this.state;
        let ShipInfoComponent: string = '';
        if (commodity.regionCode === 'POL') {
            ShipInfoComponent = '/pl';
        }
        const ShipInfo = require('./components/ship-info' + ShipInfoComponent).default;
        return (
            <div className="buybox">
                <a id="buyCart"></a>
                <Sku commodity={commodity} onPackageChange={this.packageChangeHandler} onSpuAttrChange={this.changeSkuHandler} />
                <ShipInfo
                    commodity={commodity}
                    config={config}
                    shippingFee={selectedPackage?.logisticsFee + region.remoteLogisticsFee}
                    selectedPackage={selectedPackage}
                    totalPrice={selectedPackage?.price + selectedPackage?.logisticsFee + region.remoteLogisticsFee}
                    onShipInfoChange={onShipInfoChange}
                    onSubmitOrder={onSubmitOrder}
                    onRemoteRegion={this.onRemoteRegionHandler}
                />
            </div>
        );
    }
}
